import { MostRequestHistoryResultDataWithProblem } from 'src/graphql/generated/graphql';
import clsx from 'clsx';
import styles from './index.module.css';
import { Alert } from '@otp/icons';

interface ResultDataItemProps {
  item: MostRequestHistoryResultDataWithProblem;
}

export const ResultDataItem = ({ item }: ResultDataItemProps) => {
  return (
    <div className={styles.rowWrapper}>
      <div className={clsx(styles.column, styles.columnName)}>
        <span dangerouslySetInnerHTML={{ __html: item.name || '' }} />
      </div>
      <div
        className={clsx(styles.column, {
          [styles.alert]: !!item.problem,
        })}
      >
        {!!item.problem && <Alert className="scale-75 mr-1" />}
        <span dangerouslySetInnerHTML={{ __html: item.value || '' }} />
      </div>
    </div>
  );
};
